import React from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';

const ClubMembersTable = ({ members, openModal, handleDeleteClick }) => {
    return (
        <div className="w-full">
            {/* Desktop Table View */}
            <div className="hidden md:block">
                <table className="w-full">
                    <thead>
                        <tr className="bg-gray-50 border-b border-gray-200">
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Member Name</th>
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Email</th>
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">ID (Adm/NIC)</th>
                            <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {members.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="px-6 py-8 text-center text-gray-500">
                                    No members found. Add one to get started.
                                </td>
                            </tr>
                        ) : (
                            members.map((member) => (
                                <tr key={member.id} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-6 py-4 text-sm font-medium text-gray-900">{member.name}</td>
                                    <td className="px-6 py-4 text-sm text-gray-600">{member.email}</td>
                                    <td className="px-6 py-4 text-sm text-gray-600">{member.admission_number || member.nic_number || '-'}</td>
                                    <td className="px-6 py-4 text-right">
                                        <div className="flex justify-end gap-2">
                                            <button
                                                onClick={() => openModal('edit-member', member)}
                                                className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors"
                                                title="Edit Member"
                                            >
                                                <FaEdit />
                                            </button>
                                            <button
                                                onClick={() => handleDeleteClick(member.id, 'member')}
                                                className="text-red-500 hover:text-red-700 text-sm font-medium transition-colors"
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Mobile Grid View */}
            <div className="md:hidden divide-y divide-gray-100">
                {members.length === 0 ? (
                    <div className="px-6 py-8 text-center text-gray-500">
                        No members found. Add one to get started.
                    </div>
                ) : (
                    members.map((member) => (
                        <div key={member.id} className="p-4 space-y-3">
                            <div className="flex justify-between items-start">
                                <div>
                                    <div className="font-bold text-gray-900">{member.name}</div>
                                    <div className="text-xs text-gray-500 font-medium">{member.email}</div>
                                </div>
                                <div className="text-[10px] font-black text-gray-400 uppercase tracking-widest bg-gray-50 px-2 py-1 rounded">
                                    {member.admission_number || member.nic_number || '-'}
                                </div>
                            </div>
                            <div className="flex justify-end gap-2 pt-2 border-t border-gray-50">
                                <button onClick={() => openModal('edit-member', member)} className="p-2 bg-blue-50 text-blue-600 rounded-lg text-sm"><FaEdit /></button>
                                <button onClick={() => handleDeleteClick(member.id, 'member')} className="p-2 bg-red-50 text-red-500 rounded-lg text-sm"><FaTrash /></button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ClubMembersTable;
